import Image from 'next/image';
import AirportImage from 'public/assets/airport.png';
import DefaultImage from 'public/assets/default.png';
import PartnerImage from 'public/assets/partner.png';

import {Station} from 'lib/api/backend.schemas';

export const StationImage = ({station, className}: {station: Station; className?: string}) => {
  return (
    <Image
      src={
        station?.airportStation
          ? AirportImage.src
          : station?.partner
          ? PartnerImage.src
          : DefaultImage.src
      }
      height={
        station?.airportStation
          ? AirportImage.height
          : station?.partner
          ? PartnerImage.height
          : DefaultImage.height
      }
      width={
        station?.airportStation
          ? AirportImage.width
          : station?.partner
          ? PartnerImage.width
          : DefaultImage.width
      }
      alt="Station Photo"
      sizes="(min-width: 1500px) 424px, (min-width: 1000px) calc(25.83vw + 43px), (min-width: 780px) 46vw, 93.91vw"
      className={className}
    />
  );
};

export default StationImage;
